import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { FloatTextArea } from 'ui-components/components/float-text-area';
import { InlineMessage, INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';

import { usePickupSettingsContext, usePickupSettingsContextTypes } from '../contexts/pickup-settings-context';
import style from '../style.module.less';
import messages from '../messages';

const CarrierInstructionTextbox = () => {
  usePickupSettingsContextTypes('CarrierInstructionTextbox');
  const { hasCarrierInstructionError, onUpdateInstructions, daySchedule } = usePickupSettingsContext();
  const updatedInstructions = daySchedule.Monday.instructions;
  const inlineMessageType = hasCarrierInstructionError ? INLINE_MESSAGE_TYPES.error : INLINE_MESSAGE_TYPES.sublabel;
  const inlineMessageDescriptor = hasCarrierInstructionError ? messages.carrierInstructionsTooLong : messages.TwoHundredFiftyCharactersMax;
  return (
    <>
      <label
        className={classnames(style.label, {
          [style.error]: hasCarrierInstructionError,
        })}
      >
        <FormattedMessage
          {...messages.carrierInstructions}
          values={{
            span: (chunks) => <span className={style.subtext}>{chunks}</span>,
          }}
        />
      </label>
      <div className={style['carrier-instructions-wrapper']}>
        <FloatTextArea hasError={hasCarrierInstructionError} onChange={onUpdateInstructions} value={updatedInstructions} />
        <InlineMessage type={inlineMessageType}>
          <FormattedMessage {...inlineMessageDescriptor} />
        </InlineMessage>
      </div>
    </>
  );
};

export default CarrierInstructionTextbox;
